import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonHr from "./locales/hr/common.json";
import commonEn from "./locales/en/common.json";
import commonDe from "./locales/de/common.json";
import commonFr from "./locales/fr/common.json";
import pagesHr from "./locales/hr/pages.json";
import pagesEn from "./locales/en/pages.json";
import pagesDe from "./locales/de/pages.json";
import pagesFr from "./locales/fr/pages.json";

export const SUPPORTED_LOCALES = ["hr", "en", "de", "fr"];
export const DEFAULT_LOCALE = "hr";
export const LOCALE_KEY = "tz_locale";

const resources = {
  hr: { common: commonHr, pages: pagesHr },
  en: { common: commonEn, pages: pagesEn },
  de: { common: commonDe, pages: pagesDe },
  fr: { common: commonFr, pages: pagesFr },
};

const stored = typeof window !== "undefined" ? localStorage.getItem(LOCALE_KEY) : null;
const initial = SUPPORTED_LOCALES.includes(stored) ? stored : DEFAULT_LOCALE;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initial,
    fallbackLng: DEFAULT_LOCALE,
    defaultNS: "common",
    ns: ["common", "pages"],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

export default i18n;
